import React, { useEffect, useState } from 'react';
import './style.sass';
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { postEnviarOTP, getEnviarRegistroOTP } from '../../../services/OTPservices';
import { postVerificaAceptacionCredito } from 'services/verificarCreditoCS';
import { decodeStorage } from 'functions/storageBase64';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { ModalError } from 'components/Error/ErrorModal';
import { Error500 } from 'components/Error/Error500';
import OTPInput from "otp-input-react";
import { useLogout } from 'hooks/useLogin';
import { useToken } from 'hooks/useToken'


export default function ValidarCodigo(props) {
    const {
        numeroTelefono,
        tiempo,
        setMostrarPaso2,
        activarContador,
        mostrarCopy,
        setLoading,
        keySMS,
        estaVencido,
        codigoInvalido,
        setCodigoInvalido,
        setEstaVencido,
        preNumero 
    } = props;

    const refreshToken = useToken({ firstActive: false, name: "validarCodigo" })
    const history = useHistory();
    const { logOut } = useLogout();

    //variables tomadas del storage
    const session_token = decodeStorage('session_token')
    const profileData = decodeStorage('profileData')
    const sears_numero_internet = decodeStorage('sears_numero_internet')
    const cardending = decodeStorage('cardending')

    //variables para formulario
    const [datosFormularioCodigo, setDatosFormularioCodigo] = useState(false);
    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            otp1: datosFormularioCodigo.otp1,
            otp2: datosFormularioCodigo.otp2,
            otp3: datosFormularioCodigo.otp3,
            otp4: datosFormularioCodigo.otp4,
            otp5: datosFormularioCodigo.otp5,
            otp6: datosFormularioCodigo.otp6,
        }
    });
    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);

    const [codigoOTP, setCodigoOTP] = useState();
    const [telefonoUltimosDigitos, setUltimosDigitos] = useState(); // obtiene los ultimos 4 digitos del numero de telefono

    //banderas
    const [flagDisable, setFlagDisable] = useState(true); // activa / desactiva boton de enviar codigo
    const [tiempoMostrado, setTiempoMostrado] = useState(); //variable para mostrar tiempo en copy boton reenvio

    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);

    //respuestas servicios
    const [postReenviarCodigo, setPostReenviarCodigo] = useState(false);
    const [postAceptarCredito, setPostAceptarCredito] = useState(false);

    const [newToken, setNewToken] = useState(false);


    useEffect(() => {
        setLoading(false);
    }, [])

    // guarda la informacion enviada en el formulario refreshToken.newToken
    const sendFormularioCodigo = data => {
        setDatos({
            "otp": codigoOTP
        })
        setNewToken(true)
    };

    useEffect(() => {
        if (newToken) {
            refreshToken.forceToken(true) // refresh token
            setNewToken(false);
        }
    }, [newToken])

    useEffect(() => {
        if (refreshToken.newToken) {
            SetReturnForm(true);
        }
    }, [refreshToken.newToken])

    // al recibir data del formulario, se envia servicio para validar codigo otp
    useEffect(() => {
        if (returnForm) {
            // console.log("numero ingresado= ", datos?.otp, "  key: ", keySMS)
            setDatosFormularioCodigo(datos);
            SetReturnForm(false);

            // envia informacion para aceptar credito

            if(window.location.pathname.indexOf('/solicitud-credito-claroshop/autorizar') >= 1){
                getEnviarRegistroOTP( keySMS, datos?.otp, session_token)
                .then(setPostAceptarCredito)
            
            }else{
                postVerificaAceptacionCredito(
                    {
                        "id_client": profileData.idClaro,
                        "internet_number": sears_numero_internet,
                        "last_card_digits": cardending,
                        "key": keySMS,
                        "code": datos?.otp,
                    },
                    session_token
                )
                .then(setPostAceptarCredito)
            }
            setLoading(true);
        }
    }, [returnForm])


    // revisa si el credito se acepto correctamente
    useEffect(() => {
        // console.log('postAceptarCredito: ', postAceptarCredito)
        if (postAceptarCredito) {
            if (postAceptarCredito?.statusCode === 201 || postAceptarCredito?.statusCode === 409) {
                setLoading(false);
                if(window.location.pathname.indexOf('/solicitud-credito-claroshop/autorizar') >= 1){
                    history.replace(`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/formulario`);
                }else{
                    history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`);
                }

            }
            if (postAceptarCredito?.statusCode === 200) {
                setLoading(false);
                if(window.location.pathname.indexOf('/solicitud-credito-claroshop/autorizar') >= 1){
                    history.replace(`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/formulario`);
                }else{
                    history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`);
                }
            }
            else if (postAceptarCredito?.statusCode === 404) {

                setLoading(false);
                setCodigoInvalido(true);
                setCodigoOTP("")
                document.querySelector(".contenedorOTP input").focus()
                document.querySelector(".contenedorOTP").classList.remove('disabled')
                // setCodigoOTP("")

            } else if ((postAceptarCredito?.statusCode !== 404 && postAceptarCredito?.statusCode !== 200)
                && postAceptarCredito?.statusCode < 500) {
                setShowModalErr(true);
                setErrorCode(postAceptarCredito?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(JSON.parse(postAceptarCredito?.data)?.data?.message);
                setLoading(false);
            }
            else {
                setErrorCode(500);
                setLoading(false);
            }
        }
    }, [postAceptarCredito])

    //transforma el numero de telefono para mostrar los utimos 4 digitos
    useEffect(() => {
        if (numeroTelefono) {
            setUltimosDigitos("** **** " + String(numeroTelefono.slice(-4)));

        }
    }, [numeroTelefono])


    // activa boton de validar codigo al contener los 6 digitos
    useEffect(() => {

        if (codigoOTP && codigoOTP?.length === 6) {
            setFlagDisable(false);
        }
        else {
            setFlagDisable(true);
            setCodigoInvalido(false);
        }
    }, [codigoOTP])

    // si timer llega a 0 , vacia el codigo ingresado
    useEffect(() => {
        if (estaVencido) {
            setCodigoOTP("");
            document.querySelector(".contenedorOTP").classList.add('disabled')
            setCodigoInvalido(true);
            setTimeout(function(){
                document.querySelector(".marginTop10.btn.blancoDisabled").focus()
            },500)
        }
    }, [estaVencido])

    // cambia valor de bandera para mostrar seccion de ingresar numero de telefono
    const regresarIngresarNumero = () => {
        setMostrarPaso2(false);
        document.querySelector(".contenedorOTP").classList.remove('disabled')
        activarContador()
    }

    // revisa valor de contador para agregar 0 en copy boton de reenvio
    useEffect(() => {
        if (tiempo) {
            setTiempoMostrado(tiempo);
        }
    }, [tiempo])

    //funcion para realizar peticion de reenvio de codigo
    const reenviarCodigo = () => {
        if (numeroTelefono) {
            setEstaVencido(false);
           // refreshToken.forceToken(true); // refresk token//
            // console.log("prodfile data--- ", profileData)
            // console.log("prodfile data--- ", profileData?.idClaro , "      numero:    ", numeroTelefono)
            postEnviarOTP(
                session_token,
                {
                    "id_client": profileData?.idClaro,
                    "mobile": numeroTelefono
                }
            )
                .then(setPostReenviarCodigo)
            setLoading(true);
        }
    }

    // revisa respuesta del servicio envio de sms
    useEffect(() => {
        if (postReenviarCodigo) {
            if (postReenviarCodigo?.statusCode === 200) {
                activarContador()
                setLoading(false)
                setCodigoInvalido(false)
                document.querySelector(".contenedorOTP input").focus()
                document.querySelector(".contenedorOTP").classList.remove('disabled')
            }
            else if (postReenviarCodigo?.statusCode != 401 && postReenviarCodigo?.statusCode > 200 && postReenviarCodigo?.statusCode < 500) {
                setShowModalErr(true);
                setErrorCode(postReenviarCodigo?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(JSON.parse(postReenviarCodigo?.data)?.metadata?.message);
                setLoading(false);
            }
            else if (postReenviarCodigo?.statusCode === 401) {
                logOut();
                window.location.href = `${BASE_PATH}login?redirect=${window.location.href}`
            }
            else {
                setErrorCode(500);
                setLoading(false);
            }
        }
    }, [postReenviarCodigo])

    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'verificar') {
            window.location.href = `${BASE_PATH}`;
        }
    }

    return (
        <>
            {errorCode >= 500
                ? <Error500 />
                : <div className='verificacionNumeroBox'>
                    <div className='logoCopy marginBottom35'>
                        <img src='img/icono-creditocs.svg' alt='logo-cs' width={80}></img>
                        {/* <p className='p20 marginTop30'>Confirma que eres tu con un código de un solo uso</p> */}
                        <p className='p20 marginTop30'> Acepta tu crédito con un código de un solo uso</p>
                    </div>

                    <div className=''>
                        <p className='colorGris'>Código enviado al:</p>

                        <div className='marginTop30 prefijo marginBottom35'>
                            <img src='img/cellphone.svg' alt='ico-cellphone'></img>
                            {telefonoUltimosDigitos && <p className='fontsize22 bold'>{telefonoUltimosDigitos}</p>}
                        </div>
                    </div>


                    <div className=''>

                        <form className='otpForm marginTop30' onSubmit={handleSubmit(sendFormularioCodigo)}>


                            {estaVencido &&
                                <div className='caducado'>
                                    <p className='colorRojo'>Tu código anterior ha caducado, solicita uno nuevo</p>
                                </div>
                            }

                            <OTPInput
                                value={codigoOTP}
                                onChange={setCodigoOTP}
                                autoFocus
                                OTPLength={6}
                                otpType="number"
                                disabled={false}
                                className="contenedorOTP"
                                inputClassName={codigoInvalido ? "inputOTP errorActivo" : "inputOTP"}
                            />

                            {codigoInvalido &&
                                <div className='msgError'>
                                    <p className='colorRojo'>Código inválido</p>
                                </div>
                            }

                            <div className='marginTop8p botones'>
                                <button className='btn rojoDisabled' disabled={flagDisable === true ? true : false}>Validar</button>
                            </div>
                        </form>


                        <div className='marginTop50 botones'>
                            <p className='marginTop50 fontSize13px'>¿No te ha llegado el código?</p>
                            <button className='marginTop10 btn blancoDisabled' disabled={(mostrarCopy === true) ? true : false} onClick={reenviarCodigo}>
                                Reenviar código {(mostrarCopy === true) ? `en ${tiempo}` : ""}
                            </button>

                            {preNumero
                                ?
                                    <div className='marginTop15'>
                                        <p className='link' onClick={regresarIngresarNumero}>Cambiar número</p>
                                    </div>
                                : null
                            }
                        </div>
                    </div>

                </div>
            }

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )

}